<template>
  <div class="navbar_wrap hidden-md-and-down">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/logo.png" alt="云上采..." />
      </div>
      <div class="navbar_right">
        <!-- <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          :text-color="navBackground"
          :active-text-color="activeNavBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首页</el-menu-item>
          <el-menu-item index="2" class="menu_item">关于我们</el-menu-item>
          <el-menu-item index="4" class="menu_item">最新动态</el-menu-item> 
          <el-menu-item index="5" class="menu_item">产品服务</el-menu-item>
          <el-menu-item index="7" class="menu_item">联系我们</el-menu-item>
        </el-menu> -->

        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          :text-color="navBackground"
          :active-text-color="activeNavBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item class="el-menu-item" index="1">首页</el-menu-item>
          <!-- <el-submenu index="1"  :class="{ 'home-active': activeIndex === '1' }">
            <template slot="title"> <span @click.stop="handletitlte('1')">首页</span></template>
          </el-submenu> -->
          <el-submenu index="2" :class="{ 'home-active': activeIndex === '2' }">
            <template slot="title"><span @click.stop="handletitlte('2')">关于我们</span></template>
            <el-menu-item class="el-menu-item" index="2-1" @click="goToSection('/production/contact', 'company-intro')">企业简介</el-menu-item>
            <el-menu-item class="el-menu-item" index="2-2" @click="goToSection('/production/contact', 'company-qualification')">公司资质</el-menu-item>
          </el-submenu>
          <el-submenu index="4" :class="{ 'home-active': activeIndex === '4' }">
            <template slot="title"><span @click.stop="handletitlte('4')">最新动态</span></template>
            <el-menu-item class="el-menu-item" index="4-1" @click="goToSection('/fournav/1', 'realtime-news')">实时动态</el-menu-item>
            <el-menu-item class="el-menu-item" index="4-2" @click="goToSection('/fournav/1', 'news-center')">通知公告</el-menu-item>
          </el-submenu>
          <el-submenu index="5" :class="{ 'home-active': activeIndex === '5' }">
            <template slot="title"><span @click.stop="handletitlte('5')">产品服务</span></template>
            <el-menu-item class="el-menu-item" index="5-1" @click="goToSection('/product/service', 'expert-system')">专家系统</el-menu-item>
            <el-menu-item class="el-menu-item" index="5-2" @click="goToSection('/product/service', 'info-assistant')">资讯助手</el-menu-item>
            <el-menu-item class="el-menu-item" index="5-3" @click="goToSection('/product/service', 'other-products')">其它产品</el-menu-item>
          </el-submenu>
          <el-menu-item class="el-menu-item" index="6">政采案列</el-menu-item>
          <el-submenu index="7" :class="{ 'home-active': activeIndex === '7' }">
            <template slot="title"><span @click.stop="handletitlte('7')">联系我们</span></template>
            <el-menu-item class="el-menu-item" index="7-1" @click="goToSection('/fivenav/1', 'message-board')">留言板</el-menu-item>
            <el-menu-item class="el-menu-item" index="7-2" @click="goToSection('/fivenav/1', 'contact-us')">联系我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHomeActive: true,
      activeIndex: '1',
      navBackground:'#000',
      activeNavBackground: '#E22323'
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '1',
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex
    // window.onscroll = () => {
    //   if(document.documentElement.scrollTop > 390){
    //     this.navBackground = '#fff'
    //   }else{
    //     this.navBackground = '#000'
        
    //   }
    // }
  },
  methods: {
    // 跳转到页面内的指定区域
    goToSection(path, sectionId) {
      if (this.$route.path !== path) {
        // 如果不在目标页面，先跳转页面，然后在页面加载后滚动
        this.$router.push(path).then(() => {
          this.$nextTick(() => {
            this.scrollToSection(sectionId);
          });
        });
      } else {
        // 如果已经在目标页面，直接滚动
        this.scrollToSection(sectionId);
      }
    },
    
    // 滚动到指定区域
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },
    changeCurrentPage(index) {
      this.activeIndex = index
      if (this.activeIndex == 1) {
        this.$router.push('/home').catch(() => {})
      }
      if (this.activeIndex == 2) {
        this.$router.push('/production/contact').catch(() => {})
      }
      if (this.activeIndex == 4) {
        this.$router.push('/fournav/1').catch(() => {})
      }
      if (this.activeIndex == 5) {
        this.$router.push('/product/service').catch(() => {})
      }
      if (this.activeIndex == 6) {
        this.$router.push('/GovernmentProcurementCase').catch(() => {})
      }
      if (this.activeIndex == 7) {
        this.$router.push('/fivenav/1').catch(() => {})
      }   
     
    },
    handletitlte(index) {
      console.log(index,'---------->')
      this.activeIndex = index
       // 路由跳转逻辑
       const routeMap = {
        '1': '/home',
        '2': '/production/contact',
        '4': '/fournav/1',
        '5': '/product/service',
        '7': '/fivenav/1'
      }
      
      if (routeMap[index]) {
        this.$router.push(routeMap[index]).catch(() => {});
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* 自定义首页激活状态样式 */
.home-active >>> .el-submenu__title {
  border-bottom-color: rgb(226, 35, 35) !important;
  color: rgb(226, 35, 35) !important;
}

/* 或者使用更精确的选择器 */
::v-deep .home-active .el-submenu__title {
  border-bottom-color: rgb(226, 35, 35) !important;
  color: rgb(226, 35, 35) !important;
}

.el-menu-item{
  // padding: 0 5px;
  // margin: 0 10px !important;
  // display: inline-block !important;
}
.navbar_wrap {
  width: 100%;
  max-width: 1980px;
  margin: 0 auto;
  height: 70px;
  background: #fff;
  // background: rgba(0, 0, 0, 0.3);
  // backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 120px;
        cursor: pointer;
      }
    }
    .navbar_right {
      flex: 1;
      height: 100%;
      display: flex;
      margin-left: 120px;
      align-items: center;
      // justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        // padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      // .menu_item {
      //   &:hover {
      //     font-weight: 600;
      //     background: transparent !important;
      //   }
      // }
      .right_phone {
        &:hover {
          color: #ccc;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #fff;
      }
    }
  }
}
</style>